import React from 'react';
import { DateRow, EditWithIcon, HtmlConvertor, TextRow } from 'components';
import { Images } from 'utils';
export const clientSectionsHead = [
    { name: 'name', title: 'Section Name', custom: false },
    { name: 'template', rowName: 'title', title: 'Template', custom: false },
    { name: 'createdDate', title: 'Created Date', custom: false, iconType: 'date', disabled: true },
    { name: 'updatedDate', title: 'Updated', custom: false, iconType: 'date', disabled: true },
    { name: 'createdBy', title: 'Created By', custom: false, iconType: 'date', disabled: true },
    { name: '', title: 'Action', custom: false, width: '100px' },
];

export const clientSectionsBody = (selectedId) => [
    { rowText: (item) => <TextRow name={item?.name} /> },
    { rowText: (item) => <TextRow name={item?.template?.title} /> },
    { rowText: (item) => <DateRow date={item?.createdAt} /> },
    { rowText: (item) => <DateRow date={item?.updatedAt} /> },
    { rowText: (item) => <TextRow name={item?.createdBy} /> },
    {
        button: (cb, item) => (
            <div className="flex-align-center" style={{ gap: '12px' }}>
                <EditWithIcon load={selectedId === item?.id} icon={Images.edit} handleClick={() => cb('edit')} />
                <EditWithIcon icon={Images.remove} handleClick={() => cb('delete')} />
            </div>
        ),
        notClickable: true,
    },
];

export const clientSectionsNotYet = {
    title: 'No custom sections yet',
    subTitle: 'Create reusable client sections to store frequently used information and quickly add them to forms and reports',
    image: Images.noClientYet,
};

export const CLIENT_SECTIONS_ACTION_TYPE = 'GET_CLIENT_SECTIONS';
